module.exports = __webpack_public_path__ + "img/no-data-cloud.2c24c766.png";